export default __webpack_public_path__ + "static/media/icon_green_check.43944080.svg";